import { render, staticRenderFns } from "./CostCalculator.vue?vue&type=template&id=c906ae32&lang=pug"
import script from "./CostCalculator.vue?vue&type=script&lang=js"
export * from "./CostCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports